import axios from 'axios';


export const loginUser = async (username, password) => {
  try {
    const
      response = await axios.post(`${process.env.REACT_APP_API_URL}/api/login/`, {
        username,
        password,
      });

    return response; // Return response to handle it in the component
  } catch (err) {
    throw err; // Re-throw the error to be caught in handleSubmit
  }
};

export const requestPasswordReset = async (email, username) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/password-reset-request/`, {
      email,
      username,
    });
    return response; // Return the response to handle it later in the calling function
  } catch (error) {
    throw error; // Re-throw the error to be handled in the calling function
  }
};


export const resetPassword = async (password, newtoken) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/reset-password/`, {
      token: newtoken,
      new_password: password,
    });
    return response; // Return the response to handle later in the calling function
  } catch (error) {
    throw error; // Re-throw the error to be handled in the calling function
  }
}